import {formatUserName} from "./ContactFormat";
import User from "../entities/user";

/**
 * Sort deleted users by contact name
 * @param {User} a
 * @param {User} b
 * @returns {number}
 */
export const sortDeletedUsers = (a: User, b: User) => {
    try {
        const aValue = (a.status === 'D' || !a.enabled) ? 1 : 0;
        const bValue = (b.status === 'D' || !b.enabled) ? 1 : 0;
        if (aValue === bValue) {
            return formatUserName(a).localeCompare(formatUserName(b));
        }
        else return aValue - bValue;
    }
    catch (err) {
        throw err;
    }
};